'use strict';

(function (window, document, $) {
    // Page has slider and images
    if ($('.slick-slider-default').length > 0) {
        $('.slick-slider-default').slick({
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
            nextArrow: '<button type="button" class="slick-next"><span class="lnr lnr-chevron-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev"><span class="lnr lnr-chevron-left"></span></button>'
        });
    }

    $('.selma-home-slick').slick({
        fade: true,
        lazyLoad: 'ondemand',
        autoplay: true,
        autoplaySpeed: 5000,
        nextArrow: '<button type="button" class="slick-next"><span class="lnr lnr-chevron-right"></span></button>',
        prevArrow: '<button type="button" class="slick-prev"><span class="lnr lnr-chevron-left"></span></button>'
    });

    if ($('.testimonial-slider').length > 0) {
		$('.testimonial-slider').slick({
			autoplay: true,
			autoplaySpeed: 7000,
			vertical: false,
			arrows: false,
			dots: true,
			centerMode: true,
			adaptiveHeight: true,
			centerPadding: '0 0',
		});
	}
})(window, document, jQuery);
